import axios from "axios";
import { del, get, post, patch,  put } from "./registrations_api_helper";
import * as url from "./registrations_url_helper";





// Get features
export const getRegistrations = () => get(url.GET_REGISTRATIONS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewRegistration = registration => post(url.ADD_NEW_REGISTRATION, registration, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateRegistration = registration => patch(`${url.UPDATE_REGISTRATION}/${registration.id}`,  registration);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteRegistration = registration => del(`${url.DELETE_REGISTRATION}/${registration.id}`);







export {
  //getLoggedInUser,
  
  
};
